import { render } from "./HolidayVideo.vue?vue&type=template&id=17094d39&scoped=true"
import script from "./HolidayVideo.vue?vue&type=script&lang=js"
export * from "./HolidayVideo.vue?vue&type=script&lang=js"

import "./HolidayVideo.vue?vue&type=style&index=0&id=17094d39&scoped=true&lang=css"
import "./HolidayVideo.vue?vue&type=style&index=1&id=17094d39&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17094d39"]])

export default __exports__